module.exports = __webpack_public_path__ + "img/20180815_145537_009.c2aff1d1.jpg";